module.exports = __webpack_public_path__ + "static/media/cod_burger-mb-fr.657ed2bf.jpg";